import React, { useState, useRef, useEffect } from 'react';
import './ChatInput.css';

const ChatInput = ({ onSendMessage }) => {
  const [text, setText] = useState('');
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);

  const handleAddImage = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImages(prevImages => [...prevImages, { type: 'image', data: e.target.result }]);
      };
      reader.readAsDataURL(file);
    });
    // Reset file input to allow selecting the same file again
    e.target.value = '';
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleRemoveImage = (index) => {
    setImages(prevImages => prevImages.filter((_, i) => i !== index));
  };

  const handleSendMessage = () => {
    const parts = [];
    images.forEach(image => parts.push(image));
    if (text.trim()) {
      parts.push({ type: 'text', data: text });
    }

    if (parts.length > 0) {
      onSendMessage(parts);
      setText('');
      setImages([]);
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  useEffect(() => {
    // Reset textarea height when images change
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [images]);

  return (
    <div className="ChatInput">
      <div className="InputWrapper">
        <div className="InputArea">
          {images.length > 0 && (
            <div className="ImagePreview">
              {images.map((image, index) => (
                <div key={index} className="ImagePreviewItem">
                  <img src={image.data} alt="preview" />
                  <button 
                    className="RemoveImageButton"
                    onClick={() => handleRemoveImage(index)}
                    aria-label="Remove image"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
          <textarea
            ref={textareaRef}
            value={text}
            onChange={handleTextChange}
            onKeyDown={handleKeyDown}
            className="TextInput"
            placeholder="Type a message or add an image..."
            rows={1}
          />
        </div>
        <div className="InputButtons">
          <button className="UploadButton" onClick={handleAddImage} aria-label="Upload image">
            Upload
          </button>
          <button className="SendButton" onClick={handleSendMessage} disabled={!text.trim() && images.length === 0}>
            Send
          </button>
        </div>
      </div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        multiple
        accept="image/*"
      />
    </div>
  );
};

export default ChatInput;
